import Plot from "react-plotly.js";
import { Layout } from "plotly.js";
import * as d3 from "d3";
import "plotly.js/dist/plotly-locale-de"
import React from "react";
import { LifespanDeltas, RxLifespanDto } from "../../../../api-client";
import { handleRxPlotClick } from "../../helpers/handlePlotClick";
import { getColor } from "../../helpers/locationColors";
import useStore from "../../../../helpers/useStore";
import { PatientsContext } from "../../../../stores/Patients/patients.provider";


interface ViolinPlotProps {
    rxLifespanData: RxLifespanDto[];
    deltaType: keyof LifespanDeltas;
}

const RxLifespanPlot: React.FC<ViolinPlotProps> = ({rxLifespanData, deltaType}) => {
    const patientsStore = useStore(PatientsContext);
    const groupedData = Object.groupBy(rxLifespanData, ({ locationId }) => locationId);
    
    const traces: Partial<Plotly.ViolinData>[] = [];
    // const numLocations = Object.keys(groupedData).length;
    // const colorPalette = d3.scaleOrdinal(d3['schemeTableau10']).range().slice(0, numLocations);

    Object.keys(groupedData).map((locationId, index) => {
        const color = getColor(locationId);
        const group = groupedData[locationId];
        const trace: Partial<Plotly.ViolinData> = {
            x: group?.map(entry => entry.locationId),
            y: group?.map(entry => entry.lifespanDeltas[deltaType]),
            type: "violin",
            points: "all",
            pointpos: 0,
            jitter: 0.5,
            // spanmode: "hard",
            box: {
                visible: true
            },
            meanline: {
                visible: true
            },
            line: {
                color: color,
                width: 1,
            },
            hoveron: "points",
            text: group?.map(entry => 
                `<b>Rx:</b> ${entry.rxNumber}<br><b>Patient:</b> ${entry.patient.firstName} ${entry.patient.lastName}<br>`
            ),
            hovertemplate: "%{text}",
            name: "",
            scalegroup: locationId,
        };

        traces.push(trace);
    });

    const layout: Partial<Layout> = {
        height: 400,
        autosize: true,
        xaxis: {
            tickfont: {
                family: 'Roboto', 
                size: 12,
            },
            zerolinecolor: 'rgb(204, 204, 204)',
            linecolor: 'rgb(204, 204, 204)',
        },
        yaxis: {
            title: {
                text: 'Tage',
                font: {
                    family: 'Roboto', 
                    size: 14,
                },
                standoff: 0,
            },
            tickfont: {
                family: 'Roboto', 
                size: 12,
            },
            griddash: 'dot',
            zeroline: true,
            zerolinecolor: 'rgb(204, 204, 204)',
            linecolor: 'rgb(204, 204, 204)',
            gridcolor: 'rgb(204, 204, 204)',
        },
        hoverlabel: {
            font: {
                family: 'Roboto',
                size: 12,
            }
        },
        showlegend: false,
        margin: {
            t: 40, 
            b: 50, 
            l: 50, 
            r: 35, 
        },
        modebar: {
            orientation: 'v'
        }
    };
    
    return (
        <Plot 
            data={traces} 
            layout={layout} 
            config={{ locale: 'de' }} 
            useResizeHandler={true}
            onClick={(data) => handleRxPlotClick(data, rxLifespanData, patientsStore)}
            style={{ width: "100%", height: "100%"}} 
        />
    );
}

export default RxLifespanPlot;